module.exports = __webpack_public_path__ + "static/media/process-flow-5-icon.d313d083.svg";